import { useLayout } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { hocs as pageHocs } from 'modules/page';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useBackHeader, useHideCompanyHeader } from 'shared/components';
import { getPath, Path } from 'urlBuilder';

import { PageContent } from '../components/PageContent/PageContent';
import PageSkeleton from '../components/PageContent/PageSkeleton';
import { PAGE_ID, SEARCH_REQUESTS_LIST_PAGE_ID } from '../config';
import { useLeavePage } from '../hooks/useLeavePage';
import useSearchRequestsListPageData from '../hooks/useSearchRequestsListPageData';

export const SearchRequestsListPage: FC = () => {
    const activePageId = useSelector(selectors.navigation.getActivePageId);
    const innerActivePageId = useSelector(selectors.navigation.getInnerActivePageId);

    useLayout({ hasHeader: true, hasDrawer: true });
    useSearchRequestsListPageData();
    useBackHeader(undefined, true);
    useHideCompanyHeader();
    useLeavePage();

    const generateRequestUrl = useCallback((requestId: string, companyId: string) => {
        return getPath(Path.searchRequestsWithCompany, companyId, { requestId });
    }, []);

    if (activePageId !== PAGE_ID || innerActivePageId !== SEARCH_REQUESTS_LIST_PAGE_ID) {
        return <PageSkeleton />;
    }

    return <PageContent generateRequestUrl={generateRequestUrl} requestListPage='search' />;
};

export default pageHocs.withProtected({ Page: SearchRequestsListPage });
